<template>
  <v-container fluid class="pa-0 fill-height">
    <v-card class="mx-auto pa-2 rounded-lg elevation-5" color="lighten-3">
      <template v-slot:title>
        <v-row>
          <!-- Icon and Members Title -->
          <v-col cols="12" md="12" class="d-flex align-center">
            <v-icon class="display-2 mr-2">mdi-account-cash-outline</v-icon>
            <span class="headline font-weight-bold">Alumni ({{ this.alumni.length }} Total)</span>
          </v-col>

          <v-divider></v-divider>

          <!-- File Input Form -->
          <!-- Action Buttons -->
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12">
                <v-btn 
                  color="info" 
                  prepend-icon="mdi-download" 
                  size="small"
                  block
                  @click="exportToExcel"
                  >
                  Export
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-card>

    <v-divider></v-divider>
    <v-col>
      <v-row>
        <v-col cols="12" md="4">
          <!-- Search Bar -->
          <v-text-field
            v-model="search"
            label="Search"
            class="mt-3"
            solo
          />
        </v-col>
        <!-- <v-col cols="12" md="4">
          <v-select
            v-model="selectedEntryYear"
            :items="entryYearOptions"
            label="Filter by Entry Year"
            solo
            class="mt-3"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn color="error" @click="resetFilters" class="mt-6">
            Reset Filters
          </v-btn>
        </v-col> -->
      </v-row>
    </v-col>
    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="filteredAlumni"
      :items-per-page="10"
      :search="search"
      :loading="loading"
      class="elevation-1 "
      @click:row="openDialog"
    >
      <template v-slot:item="{ item, index }">
        <tr @click="openDialog(item)">
          <td>{{ index +1 + (page - 1) * 10}}</td>
          <td>{{ item.fullName }}</td>
          <td>{{ item.sex }}</td>
          <td>{{ item.dateOfBirth }}</td>
          <td>{{ item.placeOfBirth }}</td>
          <td>{{ item.maritalStatus }}</td>
          <td>{{ item.nationality }}</td>
          <td>{{ item.permanentAddress }}</td>
          <td>{{ item.presentAddress }}</td>
          <!-- <td>{{ item.entryYear }}</td> -->
          <td>
            <v-icon small @click.stop="viewItem(item)" color="info">mdi-eye</v-icon>
            <v-icon small @click.stop="editItem(item)" color="success">mdi-pencil</v-icon>
            <v-icon small @click.stop="confirmDelete(item)" color="red">mdi-delete</v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:item-index="{ index }">
        {{ index + 1 + (page - 1) * 10 }}
      </template>
    </v-data-table>

    <!-- Pagination -->
    <v-pagination
      v-model="page"
      :length="pageCount"
      :total-visible="10"
      class="mt-3"
    />
  </v-container>

  <!-- Edit Dialog -->
  <v-dialog v-model="editDialog" max-width="1000px" class="stylish-dialog">
    <v-card class="elevation-12 rounded-lg">
      <!-- Dialog Header -->
      <v-card-title class="dialog-header">
        <h3 class="text-h6 font-weight-bold">Edit {{ selectedAlumni.fullName }}'s Information</h3>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="editDialog = false">
          <v-icon color="red">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Divider -->
      <v-divider></v-divider>

      <!-- Dialog Content -->
      <v-card-text class="pa-4 dialog-content">
        <v-form ref="editForm" @submit.prevent="submitEdit">
          <v-row dense>
            <!-- Personal Info -->
            <v-col cols="12" md="6">
              <h3 class="section-title">Personal Info</h3>
              <v-text-field v-model="selectedAlumni.firstName" label="First Name" required></v-text-field>
              <v-text-field v-model="selectedAlumni.middleName" label="Father's Name"></v-text-field>
              <v-text-field v-model="selectedAlumni.lastName" label="Grand Father's Name" required></v-text-field>
              <v-text-field v-model="selectedAlumni.sex" label="Gender" required></v-text-field>
              <v-text-field v-model="selectedAlumni.dateOfBirth" label="Date of Birth" required></v-text-field>
              <v-text-field v-model="selectedAlumni.nationality" label="Nationality" required></v-text-field>
              <v-text-field v-model="selectedAlumni.permanentAddress" label="Permanent Address" required></v-text-field>
              <v-text-field v-model="selectedAlumni.presentAddress" label="Present Address"></v-text-field>
              <v-text-field v-model="selectedAlumni.maritalStatus" label="Marital Status" required></v-text-field>
              <v-text-field v-model="selectedAlumni.entryYear" label="Entry Year" required></v-text-field>
              <v-text-field v-model="selectedAlumni.placeOfBirth" label="Place of Birth" required></v-text-field>
            
            </v-col>

            <!-- Contact Info -->
            <v-col cols="12" md="6">
              <h3 class="section-title">Contact Info</h3>
              <v-text-field v-model="selectedAlumni.contactInfo.email" label="Email" required></v-text-field>
              <v-text-field v-model="selectedAlumni.contactInfo.mobileNumber" label="Mobile Number" required></v-text-field>
              <v-text-field v-model="selectedAlumni.contactInfo.linkedin" label="LinkedIn"></v-text-field>
              <v-text-field v-model="selectedAlumni.contactInfo.preferredCommunication" label="Preferred Communication"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Education -->
          <h3 class="section-title">Education</h3>
          <v-row dense v-for="(education, index) in selectedAlumni.educations" :key="index">
            <v-col cols="12" md="6">
              <v-text-field v-model="education.level" label="Level" required></v-text-field>
              <v-text-field v-model="education.institution" label="Institution" required></v-text-field>
              <v-text-field v-model="education.fieldOfStudy" label="Field of Study" required></v-text-field>
              <v-text-field v-model="education.startYear" label="Start Year" required></v-text-field>
              <v-text-field v-model="education.endYear" label="End Year" required></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Employment -->
          <h3 class="section-title">Employment</h3>
          <v-row dense v-for="(employment, index) in selectedAlumni.employedOccupations" :key="index">
            <v-col cols="12" md="6">
              <v-text-field v-model="employment.natureOfEmployment" label="Nature of Employment" required></v-text-field>
              <v-text-field v-model="employment.employerType" label="Employer Type" required></v-text-field>
              <v-text-field v-model="employment.jobTitle" label="Job Title" required></v-text-field>
              <v-text-field v-model="employment.employerName" label="Employer Name" required></v-text-field>
              <v-text-field v-model="employment.placeOfWork" label="Place of Work" required></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Business -->
          <h3 class="section-title">Business</h3>
          <v-row dense v-for="(employment, index) in selectedAlumni.selfEmployedOccupations" :key="index">
            <v-col cols="12" md="6">
              <v-text-field v-model="employment.businessType" label="Business Type" required></v-text-field>
              <v-text-field v-model="employment.businessName" label="Business Name" required></v-text-field>
              <v-text-field v-model="employment.roleInBusiness" label="Role In Business" required></v-text-field>
              <v-text-field v-model="employment.businessAddress" label="Business Address" required></v-text-field>
              <v-text-field v-model="employment.businessPhoneNumber" label="Business Phone Number" required></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Alumni Involvement -->
          <h3 class="section-title">Alumni Involvement</h3>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-checkbox v-model="selectedAlumni.alumniInvolvement.isInvolvedInKAA" label="Involved in KAA"></v-checkbox>
              <v-textarea v-model="selectedAlumni.alumniInvolvement.involvementInKAA" label="KAA Details"></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox v-model="selectedAlumni.alumniInvolvement.isInvolvedInKSHS" label="Involved in KSHS"></v-checkbox>
              <v-textarea v-model="selectedAlumni.alumniInvolvement.involvementInKSHS" label="KSHS Details"></v-textarea>
            </v-col>
            <v-col cols="12" md="6">

              <v-textarea v-model="selectedAlumni.alumniInvolvement.futurePlanInKSHS" label="Future Plans in KSHS"></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <!-- Dialog Actions -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="editDialog = false">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="submitEdit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Dialog Popup -->
  <!-- Details Dialog -->
  <v-dialog v-model="dialog" max-width="1000px" class="stylish-dialog">
    <v-card class="elevation-12 rounded-lg">
      <!-- Dialog Header -->
      <v-card-title class="dialog-header">
        <h3 class="text-h6 font-weight-bold">{{ selectedAlumni.fullName }}'s Details</h3>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon color="red">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Divider -->
      <v-divider></v-divider>
      
      <!-- Dialog Content -->
      <v-card-text class="pa-4 dialog-content">
        <v-row dense>
          <!-- Personal Info -->
          <v-col cols="12" md="6">
            <h3 class="section-title">Personal Info</h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <p><strong>Full Name:</strong> {{ selectedAlumni?.fullName }}</p>
                  <p><strong>Gender:</strong> {{ selectedAlumni?.sex }}</p>
                  <p><strong>Date of Birth:</strong> {{ selectedAlumni?.dateOfBirth }}</p>
                  <p><strong>Nationality:</strong> {{ selectedAlumni?.nationality }}</p>
                  <p><strong>Address:</strong> {{ selectedAlumni?.permanentAddress }}</p>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <!-- Contact Info -->
          <v-col cols="12" md="6">
            <h3 class="section-title">Contact Info</h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <p><strong>Email:</strong> {{ selectedAlumni?.contactInfo?.email }}</p>
                  <p><strong>Mobile:</strong> {{ selectedAlumni?.contactInfo?.mobileNumber }}</p>
                  <p><strong>LinkedIn:</strong> {{ selectedAlumni?.contactInfo?.linkedin }}</p>
                  <p><strong>Preferred Communication:</strong> {{ selectedAlumni?.contactInfo?.preferredCommunication }}</p>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Education -->
        <h3 class="section-title">Education</h3>
        <v-list two-line>
          <v-list-item v-for="education in selectedAlumni.educations" :key="education.id">
            <v-list-item-content>
              <p><strong>Level:</strong> {{ education?.level }}</p>
              <p><strong>Institution:</strong> {{ education?.institution }}</p>
              <p><strong>Field of Study:</strong> {{ education?.fieldOfStudy }}</p>
              <p><strong>Years:</strong> {{ education?.startYear }} - {{ education?.endYear }}</p>
            </v-list-item-content>
            <v-divider></v-divider>
          </v-list-item>
        </v-list>

        <v-divider class="my-4"></v-divider>

        <!-- Employment -->
        <h3 class="section-title">Employment</h3>
        <v-list two-line>
          <v-list-item v-for="employment in selectedAlumni.employedOccupations" :key="employment.id">
            <v-list-item-content>
              <p><strong>Nature of Employment:</strong> {{ employment?.natureOfEmployment }}</p>
              <p><strong>Employer Type:</strong> {{ employment?.employerType }}</p>
              <p><strong>Job Title:</strong> {{ employment?.jobTitle }}</p>
              <p><strong>Employer:</strong> {{ employment?.employerName }}</p>
              <p><strong>Place of Work:</strong> {{ employment?.placeOfWork }}</p>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="my-4"></v-divider>

        <!-- Business -->
        <h3 class="section-title">Business</h3>
        <v-list two-line>
          <v-list-item v-for="employment in selectedAlumni.selfEmployedOccupations" :key="employment.id">
            <v-list-item-content>
              <p><strong>Business Type:</strong> {{ employment?.businessType }}</p>
              <p><strong>Business Name:</strong> {{ employment?.businessName }}</p>
              <p><strong>Role In Business:</strong> {{ employment?.roleInBusiness }}</p>
              <p><strong>Business Address:</strong> {{ employment?.businessAddress }}</p>
              <p><strong>Business Phone:</strong> {{ employment?.businessPhoneNumber }}</p>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="my-4"></v-divider>

        <!-- Alumni Involvement -->
        <h3 class="section-title">Alumni Involvement</h3>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <p><strong>Involved in KAA:</strong> {{ selectedAlumni?.alumniInvolvement?.isInvolvedInKAA ? "Yes" : "No" }}</p>
              <p><strong>KAA Details:</strong> {{ selectedAlumni?.alumniInvolvement?.involvementInKAA }}</p>
              <p><strong>Involved in KSHS:</strong> {{ selectedAlumni?.alumniInvolvement?.isInvolvedInKSHS ? "Yes" : "No" }}</p>
              <p><strong>KSHS Details:</strong> {{ selectedAlumni?.alumniInvolvement?.involvementInKSHS }}</p>
              <p><strong>Future Plans in KSHS:</strong> {{ selectedAlumni?.alumniInvolvement?.futurePlanInKSHS }}</p>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Delete Confirmation Dialog -->
  <v-dialog v-model="deleteDialog" max-width="400px">
    <v-card>
      <v-card-title class="headline">Confirm Deletion</v-card-title>
      <v-card-text>
        Are you sure you want to delete this member?
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="deleteItem">Yes, Delete</v-btn>
        <v-btn @click="deleteDialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Snackbars -->
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
    {{ snackbar.text }}
    <v-btn text @click="snackbar.show = false" color="red">Close</v-btn>
  </v-snackbar>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      file: null,
      excelData: [], 
      selectedEntryYear: null, // Currently selected entry year
      entryYearOptions: [], // List of unique entry years
      alumni: [], // Store API data
      loading: false, // Loading indicator
      search: '', // Search filter
      page: 1, // Current page number
      itemsPerPage: 10, // Items per page
      dialog: false, // Dialog visibility
      editDialog: false, // Edit dialog visibility
      // selectedAlumni: {}, // Selected member for the dialog
      deleteDialog: false,
      snackbar: {
        show: false,
        text: '',
        color: ''
      },
      selectedAlumni: { // Selected member for dialog
        personalInfo: {
          firstName: '',
          middleName: '',
          lastName: '',
          dateOfBirth: '',
          placeOfBirth: '',
          maritalStatus: '',
          nationality: '',
          permanentAddress: '',
          presentAddress: '',
          entryYear: '',
          sex: '',
        },
        contactInfo: {
          email: '',
          mobileNumber: '',
          linkedin: '',
          preferredCommunication: ''
        },
        educations: [], // Must be an array
        employedOccupations: [], // Must be an array
        selfEmployedOccupations: [], // Must be an array
        alumniInvolvement: {
          isInvolvedInKAA: false,
          involvementInKAA: '',
          isInvolvedInKSHS: false,
          involvementInKSHS: '',
          futurePlanInKSHS: ''
        }
      },
      headers: [
        { title: 'No.', value: 'index', sortable: false },
        { title: "Full Name", align: 'start', value: "fullName" }, // Use the computed fullName field
        { title: 'Sex', value: 'sex' ,align: 'start'},
        { title: 'Date of Birth', value: 'dateOfBirth',align: 'start', sortable: true },
        { title: 'Place of Birth', value: 'placeOfBirth' },
        { title: 'Marital Status', value: 'maritalStatus' },
        { title: 'Nationality', value: 'nationality' },
        { title: 'Permanent Address', value: 'permanentAddress',align: 'start', sortable: true },
        { title: 'Current Address', value: 'presentAddress',align: 'start', sortable: false },
        // { title: 'KSHS Entry Year', value: 'entryYear',align: 'start', sortable: true },
        { title: 'Actions', value: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.filteredAlumni.length / this.itemsPerPage);
    },
    filteredAlumni() {
      // Filter alumni based on search and handle pagination
      var filtered = this.alumni.filter(member =>
        Object.values(member).some(val =>
          String(val).toLowerCase().includes(this.search.toLowerCase())
        )
      );

      // Apply entry year filter if selected
      if (this.selectedEntryYear) {
        filtered = this.alumni.filter((member) => member.entryYear === this.selectedEntryYear);
      }

      // Slice for pagination
      const start = (this.page - 1) * this.itemsPerPage;
      const end = this.page * this.itemsPerPage;
      return filtered.slice(start, end);
    },
    pageCount() {
      // Calculate total pages for pagination
      return Math.ceil(this.alumni.length / this.itemsPerPage);
    }
  },
  methods: {
    resetFilters() {
      this.search = '';
      this.selectedEntryYear = null;
    },
    editItem(item) {
      console.log(item)
      this.selectedAlumni = item; // Set the clicked row's data
      this.editDialog = true; // Open the dialog
    },
    openDialog(item) {
      this.selectedAlumni = item; // Set the clicked row's data
      this.dialog = true; // Open the dialog
    },
    async fetchMembers() {
      this.loading = true;
      try {
        const response = await axios.get('https://kshsapi.mgemachines.com/api/alumni/all');
        console.log(response.data)
        this.alumni = response.data.map((alumni) => ({
          ...alumni,
          fullName: `${alumni.firstName} ${alumni.middleName} ${alumni.lastName}`,
        }));

        // Populate unique entry years for the filter
        this.entryYearOptions = [...new Set(this.alumni.map((alumni) => alumni.entryYear))].sort();
      } catch (error) {
        console.error('Error fetching alumni:', error);
      } finally {
        this.loading = false;
      }
    },
    submitEdit() {
    console.log(this.selectedAlumni)
    this.selectedAlumni.personalInfo = {
                                        firstName : this.selectedAlumni.firstName,
                                        middleName : this.selectedAlumni.middleName,
                                        lastName : this.selectedAlumni.lastName,
                                        dateOfBirth : this.selectedAlumni.dateOfBirth, 
                                        placeOfBirth : this.selectedAlumni.placeOfBirth, 
                                        maritalStatus : this.selectedAlumni.maritalStatus,
                                        entryYear : this.selectedAlumni.entryYear,
                                        maritalStatus : this.selectedAlumni.maritalStatus,
                                        nationality : this.selectedAlumni.nationality,
                                        permanentAddress : this.selectedAlumni.permanentAddress,
                                        presentAddress : this.selectedAlumni.presentAddress,
                                        sex : this.selectedAlumni.sex,

                                      }
      console.log(this.selectedAlumni)
      // Handle save action for edit dialog
      axios.put(`https://kshsapi.mgemachines.com/api/alumni/${this.selectedAlumni.id}`, this.selectedAlumni)
        .then(() => {
          this.snackbar = {
            show: true,
            text: 'Alumni updated successfully',
            color: 'success'
          };
          this.editDialog = false;
          this.fetchMembers(); // Refresh the list after saving
        })
        .catch(error => {
          console.error('Error updating Alumni:', error);
          this.snackbar = {
            show: true,
            text: 'Error updating Alumni',
            color: 'error'
          };
        });
    },
    viewItem(item) {
      // Handle view action
      this.openDialog(item);
    },
    // editItem(item) {
    //   // Handle edit action
    //   this.selectedAlumni = item;

    //   this.editDialog = true;
    //   // this.$router.push(`/alumni/${item.id}/edit`);
    // },
    confirmDelete(item) {
      this.selectedAlumni = item;
      this.deleteDialog = true;
    },
    deleteItem() {
      // Handle delete action
      axios.delete(`https://kshsapi.mgemachines.com/api/alumni/${this.selectedAlumni.id}`)
        .then(() => {
          this.snackbar = {
            show: true,
            text: 'Alumni deleted successfully',
            color: 'success'
          };
          this.deleteDialog = false;
          this.fetchMembers(); // Refresh the list after deletion
        })
        .catch(error => {
          console.error('Error deleting Alumni:', error);
        });
    },
    showSuccess(message) {
      this.snackbar = {
        show: true,
        text: message,
        color: 'success'
      };
    },
    showError(message) {
      this.snackbar = {
        show: true,
        text: message,
        color: 'error'
      };
    },
    exportToExcel() {
      try {
        console.log(this.alumni)
        // Prepare the data for Excel
        const personalInfo = this.filteredAlumni;

        // Map the data to match the required Excel format
        const dataForExcel = personalInfo.map((personalInfo, index) => ({
          ID: index + 1,
          "Full Name": personalInfo.fullName,
          "Gender": personalInfo.sex,
          "Date of Birth": personalInfo.dateOfBirth,
          "Place of Birth": personalInfo.placeOfBirth,
          "Marital Status": personalInfo.maritalStatus,
          "Nationality": personalInfo.nationality,
          "Permanent Address": personalInfo.permanentAddress,
          "Current Address": personalInfo.presentAddress,
          "KSHS Entry Year": personalInfo.entryYear
        }));
        console.log(dataForExcel)
        // Create a new workbook and add a worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dataForExcel);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Alumni Personal Info');

        // Export the workbook to an Excel file
        XLSX.writeFile(workbook, 'Alumni.xlsx');
      } catch (error) {
        console.error('Error exporting data to Excel:', error);
      }
    }
  },
  mounted() {
    this.fetchMembers();
  },
  watch: {
    $route(to, from) {
      if (to.name === 'AlumniList') {
        this.fetchMembers();
      }
    }
  }
};
</script>
<style scoped>

.world-class-dialog .dialog-card {
  border-radius: 12px;
  overflow: hidden;
}

.gradient-bg {
  background: linear-gradient(45deg, #e51e2f, #580101);
  padding: 16px;
}

.section-title {
  font-weight: bold;
  margin-bottom: 16px;
}

.dialog-content .v-text-field,
.dialog-content .v-textarea,
.dialog-content .v-select {
  margin-bottom: 16px;
}
.stylish-dialog-card {
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.dialog-content {
  font-size: 1.1rem;
  line-height: 1.6;
}

.v-list-item-content {
  padding: 8px 0;
  color: #555;
}

.v-card-title {
  color: #3f51b5;
}

.v-btn {
  text-transform: none;
  font-weight: 600;
  font-size: 1rem;
}

.stylish-table {
  border-radius: 8px;
  overflow: hidden;
  background-color: #fafafa;
}

.v-img {
  border-radius: 4px;
}

.v-divider {
  background-color: #ddd;
}

.stylish-dialog .v-card {
  border-radius: 12px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.25);
  background: linear-gradient(145deg, #ffffff, #f3f3f3);
}

/* Header */
.dialog-header {
  background-color: #aa121f;
  color: white;
  padding: 16px;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Close Icon */
.dialog-header v-btn {
  color: white;
}

/* Section Titles */
.section-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #3f51b5;
  margin-bottom: 10px;
  text-transform: uppercase;
}

/* Dialog Content */
.dialog-content p {
  margin: 5px 0;
  font-size: 1rem;
  color: #424242;
}

.dialog-content p strong {
  color: #3f51b5;
}

/* Lists */
.v-list-item-content p {
  margin: 4px 0;
}

/* Dividers */
.v-divider {
  background-color: #e0e0e0 !important;
}

/* Hover Effects */
.v-list-item:hover {
  background-color: #f4f4f4;
  transition: all 0.3s ease;
}

/* Responsive Design */
@media (max-width: 600px) {
  .dialog-header {
    font-size: 1rem;
    padding: 12px;
  }

  .section-title {
    font-size: 1rem;
  }

  .dialog-content p {
    font-size: 0.9rem;
  }
}
</style>